// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-collection-C":"C_power-ocean-collection-C__ZTAR6"};